import classNames from 'classnames';
import { Heading } from 'yoso';
import { Badge } from '~/components/Badge/Badge';
import { BaseCard } from '~/components/Card';
import { Content } from '~/components/Content';
import { T } from '~/components/I18n';
import { Boost2D, D, Verified } from '~/components/Icon';
import { DescriptionList } from '~/components/List/Description/DescriptionList';
import { NftCardProps } from '~/components/Nft/Card';
import { StoreSaleNftModel } from '~/components/Nft/Store/StoreNft.hooks';
import { Pair } from '~/components/Pair';
import { OpenDay } from '~/components/Timer/OpenDay/OpenDay';
import { SaleTimer } from '~/components/Timer/SaleTimer';
import { regularFormat } from '~/components/Util';
import { format } from '~/components/Util/number';
import styles from './StoreNftCard.module.scss';
/* eslint-disable @typescript-eslint/no-unused-vars */

export type StoreNftCardProps = NftCardProps & StoreSaleNftModel;
export const StoreNftCard = ({
  title,
  description,
  originContentsUrl,
  contentsUrl,
  contentsType,
  openAt,
  closeAt,
  saleStatus,
  galleryId,
  isPrivateSale,

  id,
  currency,
  likeCount,
  liked,
  price,
  saleId,
  marketSaleId,
  owner,
  upcomingAt,
  serialNumber,
  brandId,
  category,
  labels,
  imageLabels,
  optionLabels: [boostLabel] = [],
  goodsProperties,
  className,
  onSale,
  primaryCurrency,
  primaryPrice,
  secondaryCurrency,
  secondaryPrice,
  partnerKey,
  openAlarmRegistered,

  donReward,
  ...cardProps
}: StoreNftCardProps) => (
  <BaseCard className={classNames(className, styles.root)} {...cardProps}>
    <div className={styles.header}>
      <Content
        originContentsUrl={originContentsUrl}
        contentsUrl={contentsUrl}
        contentsType="IMAGE"
        className={styles.content}
      />
      <Badge color="white" className={styles.mobileBadge}>
        {saleStatus === 'FOR_SALE' ? (
          <T name="citizen_b2c_status_forsale" />
        ) : (
          <OpenDay openAt={openAt} />
        )}
      </Badge>
    </div>
    <div className={styles.body}>
      <div className={styles.pcBadgeWrapper}>
        {saleStatus === 'FOR_SALE' && (
          <Badge color="grey" className={styles.pcBadge}>
            <T name="citizen_b2c_status_forsale" />
          </Badge>
        )}
        <Badge color="grey" className={styles.pcBadge}>
          <SaleTimer saleStatus={saleStatus} openAt={openAt} closeAt={closeAt} />
        </Badge>
      </div>
      <Heading level={5} className={styles.heading}>
        <span className={styles.title}>{title}</span>
        {isPrivateSale && <Verified className={styles.verified} />}
      </Heading>
      <p className={styles.price}>
        <Pair
          className={styles.pair}
          primaryPrice={primaryPrice}
          primaryCurrency={primaryCurrency}
          secondaryCurrency={secondaryCurrency}
          secondaryPrice={secondaryPrice}
        />
      </p>
      <p className={styles.description}>{description}</p>
      <p className={styles.date}>
        {regularFormat(openAt)} - {regularFormat(closeAt)}
      </p>
      <DescriptionList className={styles.list} layout="inline">
        {!!donReward && (
          <>
            <dt>
              <D className={styles.icon} />
            </dt>
            <dd>{format(donReward)}</dd>
          </>
        )}
        {boostLabel && (
          <>
            <dt>
              <Boost2D className={styles.icon} />
            </dt>
            <dd>Boost</dd>
          </>
        )}
      </DescriptionList>
    </div>
  </BaseCard>
);
